import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CrowdCellInverseIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M10.9408 2L20 4V15.3875L11.7201 22L3 20V8.42523L10.9408 2Z'
				fill='#4D4DB3'
			/>
			<path
				d='M11.7201 10.5L20 4M11.7201 10.5L3 8.42523M11.7201 10.5V22M20 4L10.9408 2L3 8.42523M20 4V15.3875L11.7201 22M3 8.42523V20L11.7201 22'
				stroke='white'
			/>
			<path
				d='M11.5 10.5L3 8.5V20L11.5 22V10.5Z'
				fill='white'
			/>
		</svg>
	);
};

export default CrowdCellInverseIcon;

